import {createSlice} from "@reduxjs/toolkit";

const slice = createSlice({
    name: 'invoiceManagement',
    initialState: {modalIsOpen: false, selectedProjectId: undefined},
    reducers: {
        setInvoiceModalIsOpen: (state, {payload}) => {
            state.modalIsOpen = payload
        },
        setInvoiceSelectedProjectId: (state, {payload}) => {
            state.selectedProjectId = payload
        }
    }
});

export default slice.reducer;

export const {setInvoiceModalIsOpen, setInvoiceSelectedProjectId} = slice.actions;

export const selectModalIsOpen = state => state.invoiceManagement.modalIsOpen;
export const selectSelectedProjectId = state => state.invoiceManagement.selectedProjectId;
